import {Component, Input} from '@angular/core';
import {isDate} from 'moment/moment';
import {AdvancedFilterOperatorEnum, AdvancedFiltersOperatorTranslations, AdvanceFilterParamType, IAdvanceFilter} from '../advance-filter';

@Component({
  selector: 'app-applied-filter-filter-value-preview',
  templateUrl: './applied-filter-value-preview.component.html',
  styleUrl: './applied-filter-value-preview.component.scss'
})
export class AppliedFilterValuePreviewComponent {
    @Input() filter: IAdvanceFilter<AdvanceFilterParamType>
    protected readonly AdvancedFiltersOperatorTranslations = AdvancedFiltersOperatorTranslations;
    protected readonly AdvancedFilterOperatorEnum = AdvancedFilterOperatorEnum;
    protected readonly dateFormat = "DD-MMM-YYYY"
    protected readonly Date = Date;
    protected readonly isDate = isDate;
}
